import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 0C18.6274 0 24 5.37259 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12C0 5.37259 5.37259 0 12 0ZM12 1.5C6.21027 1.5 1.5 6.21027 1.5 12C1.5 17.7897 6.21027 22.5 12 22.5C17.7897 22.5 22.5 17.7897 22.5 12C22.5 6.21027 17.7897 1.5 12 1.5ZM11.3721 6.25C11.762 6.25 12.0828 6.54734 12.1191 6.92773L12.1221 7V12.2451L15.792 15.9141C16.0847 16.207 16.0847 16.6817 15.792 16.9746C15.6456 17.121 15.4535 17.1942 15.2617 17.1943C15.0939 17.1943 14.9255 17.1384 14.7881 17.0264L14.7314 16.9746L10.8418 13.0859C10.7468 12.9909 10.6923 12.8752 10.6621 12.7539L10.6465 12.6797C10.6412 12.6585 10.6372 12.637 10.6338 12.6152L10.6289 12.5762L10.6221 12.5V7C10.6221 6.58574 10.9578 6.25008 11.3721 6.25Z"
        fill="#B5D7F4"
      />
    </svg>
  );
}

export default Icon;
